module.exports = __webpack_public_path__ + "static/media/financials-income-chart.1abbe6cb.svg";